(function () {
  'use strict';

  // The "Törzsvásárlói Klub" popup (loyalty-club-popup.liquid, its own inline timer) and
  // the newsletter popup (newsletter-popup.liquid, driven by theme.js's built-in PopIn/
  // NewsletterPopup component) each auto-open on their own independent delay, with no
  // awareness of one another. They are NOT gated behind the cookie-consent banner -
  // both are allowed to appear alongside it.
  //
  // On mobile specifically (see user report), the newsletter popup must NEVER appear on
  // its own independent timer at all - it should only ever appear ~1s after the loyalty
  // popup is closed (whenever that happens), full stop. We patch the instance's own
  // `show` method (instead of reacting to the `open` attribute after the fact) so the
  // automatic timer's call never opens the dialog in the first place: reacting after
  // the attribute is already set is visible as a flash (the enter animation has already
  // started by the time a MutationObserver callback can run and close it again) - see
  // user report: "still pops up then quickly disappears".
  //
  // On desktop, both popups just keep their own independent timers with no stacking
  // prevention at all - if they happen to coincide, both stay open, since auto-closing
  // one right after it opens is what produced the "pops up then disappears" report.
  //
  // In both cases, a manual open (the footer's "Hírlevél" link, aria-controls=
  // "newsletter-popup") is marked via a capture-phase click listener BEFORE the
  // dialog's own click handler runs, so it is never affected by any of this - it opens
  // immediately as normal, loyalty popup or not.
  var RETRIGGER_DELAY_MS = 1000;
  var MOBILE_MEDIA_QUERY = '(max-width: 699px)';

  function init() {
    var loyaltyPopup = document.querySelector('[id^="loyalty-club-popup"]');
    var newsletterPopup = document.getElementById('newsletter-popup');
    if (!loyaltyPopup || !newsletterPopup) return;

    function loyaltyIsOpen() {
      return loyaltyPopup.hasAttribute('open');
    }

    var allowNextShow = false;

    document.addEventListener(
      'click',
      function (event) {
        var control = event.target.closest('[aria-controls="newsletter-popup"]');
        if (control && !newsletterPopup.hasAttribute('open')) {
          newsletterPopup.dataset.manualOpen = 'true';
          allowNextShow = true;
        }
      },
      true
    );

    if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
      // Shadow the instance's `show` method: only a call that first flips
      // `allowNextShow` (a manual click, or our own scheduled re-trigger below) is
      // allowed through to the real implementation. The automatic timer inside
      // NewsletterPopup.connectedCallback calls `this.show()` the exact same way a
      // manual click does, so gating it here - before `open` is ever set - is the
      // only way to suppress it without a visible flash.
      var realShow = newsletterPopup.show.bind(newsletterPopup);
      newsletterPopup.show = function () {
        if (!allowNextShow) {
          return Promise.resolve();
        }
        allowNextShow = false;
        return realShow();
      };

      var wasLoyaltyOpen = loyaltyIsOpen();
      var loyaltyCloseObserver = new MutationObserver(function () {
        var isOpenNow = loyaltyIsOpen();
        if (wasLoyaltyOpen && !isOpenNow) {
          setTimeout(function () {
            allowNextShow = true;
            newsletterPopup.show();
          }, RETRIGGER_DELAY_MS);
        }
        wasLoyaltyOpen = isOpenNow;
      });
      loyaltyCloseObserver.observe(loyaltyPopup, { attributes: true, attributeFilter: ['open'] });

      return;
    }

    // Desktop: no forced stacking prevention - once either popup is shown
    // (after the privacy-banner gate above has cleared), it stays open rather
    // than being auto-closed, since auto-closing it right after it opens is
    // what produced the "pops up then disappears" report on desktop.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
